/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as testTestRouteImport } from './routes/(test)/test'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedReviewIndexRouteImport } from './routes/_authenticated/review/index'
import { Route as AuthenticatedRechargeOrdersIndexRouteImport } from './routes/_authenticated/recharge-orders/index'
import { Route as AuthenticatedPromptsIndexRouteImport } from './routes/_authenticated/prompts/index'
import { Route as AuthenticatedEditorIndexRouteImport } from './routes/_authenticated/editor/index'
import { Route as AuthenticatedAnalyticsIndexRouteImport } from './routes/_authenticated/analytics/index'
import { Route as AuthenticatedAdminAnnouncementIndexRouteImport } from './routes/_authenticated/admin-announcement/index'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'
import { Route as AuthenticatedChatsSessionIdRouteImport } from './routes/_authenticated/chats/$sessionId'
import { Route as AuthenticatedSuperAdminAdminsIndexRouteImport } from './routes/_authenticated/super-admin/admins/index'
import { Route as AuthenticatedAdminTemplatesIndexRouteImport } from './routes/_authenticated/admin/templates/index'
import { Route as AuthenticatedAdminSystemEnginesIndexRouteImport } from './routes/_authenticated/admin/system-engines/index'
import { Route as AuthenticatedAdminSystemConfigsIndexRouteImport } from './routes/_authenticated/admin/system-configs/index'
import { Route as AuthenticatedAdminIncentiveIndexRouteImport } from './routes/_authenticated/admin/incentive/index'
import { Route as AuthenticatedAdminHelpCenterIndexRouteImport } from './routes/_authenticated/admin/help-center/index'
import { Route as AuthenticatedAdminGuestManagementIndexRouteImport } from './routes/_authenticated/admin/guest-management/index'
import { Route as AuthenticatedAdminCreatorEarningsIndexRouteImport } from './routes/_authenticated/admin/creator-earnings/index'
import { Route as AuthenticatedAdminAuditLogsIndexRouteImport } from './routes/_authenticated/admin/audit-logs/index'
import { Route as AuthenticatedAdminAiProvidersIndexRouteImport } from './routes/_authenticated/admin/ai-providers/index'
import { Route as AuthenticatedChatsNewEngineIdRouteImport } from './routes/_authenticated/chats/new/$engineId'

const AuthenticatedWorkshopIndexLazyRouteImport = createFileRoute(
  '/_authenticated/workshop/',
)()
const AuthenticatedSettingsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/settings/',
)()
const AuthenticatedPaymentIndexLazyRouteImport = createFileRoute(
  '/_authenticated/payment/',
)()
const AuthenticatedMessagesIndexLazyRouteImport = createFileRoute(
  '/_authenticated/messages/',
)()
const AuthenticatedHelpCenterIndexLazyRouteImport = createFileRoute(
  '/_authenticated/help-center/',
)()
const AuthenticatedAnnouncementIndexLazyRouteImport = createFileRoute(
  '/_authenticated/announcement/',
)()
const AuthenticatedSettingsUserCardLazyRouteImport = createFileRoute(
  '/_authenticated/settings/user-card',
)()
const AuthenticatedSettingsInviteLazyRouteImport = createFileRoute(
  '/_authenticated/settings/invite',
)()
const AuthenticatedSettingsEarningsLazyRouteImport = createFileRoute(
  '/_authenticated/settings/earnings',
)()
const AuthenticatedSettingsAppearanceLazyRouteImport = createFileRoute(
  '/_authenticated/settings/appearance',
)()
const AuthenticatedPaymentResultLazyRouteImport = createFileRoute(
  '/_authenticated/payment/result',
)()

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const testTestRoute = testTestRouteImport.update({
  id: '/(test)/test',
  path: '/test',
  getParentRoute: () => rootRouteImport,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWorkshopIndexLazyRoute =
  AuthenticatedWorkshopIndexLazyRouteImport.update({
    id: '/workshop/',
    path: '/workshop/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/workshop/index.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsIndexLazyRoute =
  AuthenticatedSettingsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/index.lazy').then((d) => d.Route),
  )
const AuthenticatedPaymentIndexLazyRoute =
  AuthenticatedPaymentIndexLazyRouteImport.update({
    id: '/payment/',
    path: '/payment/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/payment/index.lazy').then((d) => d.Route),
  )
const AuthenticatedMessagesIndexLazyRoute =
  AuthenticatedMessagesIndexLazyRouteImport.update({
    id: '/messages/',
    path: '/messages/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/messages/index.lazy').then((d) => d.Route),
  )
const AuthenticatedHelpCenterIndexLazyRoute =
  AuthenticatedHelpCenterIndexLazyRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/help-center/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAnnouncementIndexLazyRoute =
  AuthenticatedAnnouncementIndexLazyRouteImport.update({
    id: '/announcement/',
    path: '/announcement/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/announcement/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedReviewIndexRoute =
  AuthenticatedReviewIndexRouteImport.update({
    id: '/review/',
    path: '/review/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRechargeOrdersIndexRoute =
  AuthenticatedRechargeOrdersIndexRouteImport.update({
    id: '/recharge-orders/',
    path: '/recharge-orders/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPromptsIndexRoute =
  AuthenticatedPromptsIndexRouteImport.update({
    id: '/prompts/',
    path: '/prompts/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/prompts/index.lazy').then((d) => d.Route),
  )
const AuthenticatedEditorIndexRoute =
  AuthenticatedEditorIndexRouteImport.update({
    id: '/editor/',
    path: '/editor/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAnalyticsIndexRoute =
  AuthenticatedAnalyticsIndexRouteImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminAnnouncementIndexRoute =
  AuthenticatedAdminAnnouncementIndexRouteImport.update({
    id: '/admin-announcement/',
    path: '/admin-announcement/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/admin-announcement/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsUserCardLazyRoute =
  AuthenticatedSettingsUserCardLazyRouteImport.update({
    id: '/user-card',
    path: '/user-card',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/user-card.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsInviteLazyRoute =
  AuthenticatedSettingsInviteLazyRouteImport.update({
    id: '/invite',
    path: '/invite',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/invite.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsEarningsLazyRoute =
  AuthenticatedSettingsEarningsLazyRouteImport.update({
    id: '/earnings',
    path: '/earnings',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/earnings.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsAppearanceLazyRoute =
  AuthenticatedSettingsAppearanceLazyRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/appearance.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedPaymentResultLazyRoute =
  AuthenticatedPaymentResultLazyRouteImport.update({
    id: '/payment/result',
    path: '/payment/result',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/payment/result.lazy').then((d) => d.Route),
  )
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChatsSessionIdRoute =
  AuthenticatedChatsSessionIdRouteImport.update({
    id: '/chats/$sessionId',
    path: '/chats/$sessionId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuperAdminAdminsIndexRoute =
  AuthenticatedSuperAdminAdminsIndexRouteImport.update({
    id: '/super-admin/admins/',
    path: '/super-admin/admins/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminTemplatesIndexRoute =
  AuthenticatedAdminTemplatesIndexRouteImport.update({
    id: '/admin/templates/',
    path: '/admin/templates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminSystemEnginesIndexRoute =
  AuthenticatedAdminSystemEnginesIndexRouteImport.update({
    id: '/admin/system-engines/',
    path: '/admin/system-engines/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminSystemConfigsIndexRoute =
  AuthenticatedAdminSystemConfigsIndexRouteImport.update({
    id: '/admin/system-configs/',
    path: '/admin/system-configs/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminIncentiveIndexRoute =
  AuthenticatedAdminIncentiveIndexRouteImport.update({
    id: '/admin/incentive/',
    path: '/admin/incentive/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminHelpCenterIndexRoute =
  AuthenticatedAdminHelpCenterIndexRouteImport.update({
    id: '/admin/help-center/',
    path: '/admin/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminGuestManagementIndexRoute =
  AuthenticatedAdminGuestManagementIndexRouteImport.update({
    id: '/admin/guest-management/',
    path: '/admin/guest-management/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminCreatorEarningsIndexRoute =
  AuthenticatedAdminCreatorEarningsIndexRouteImport.update({
    id: '/admin/creator-earnings/',
    path: '/admin/creator-earnings/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminAuditLogsIndexRoute =
  AuthenticatedAdminAuditLogsIndexRouteImport.update({
    id: '/admin/audit-logs/',
    path: '/admin/audit-logs/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminAiProvidersIndexRoute =
  AuthenticatedAdminAiProvidersIndexRouteImport.update({
    id: '/admin/ai-providers/',
    path: '/admin/ai-providers/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChatsNewEngineIdRoute =
  AuthenticatedChatsNewEngineIdRouteImport.update({
    id: '/chats/new/$engineId',
    path: '/chats/new/$engineId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/test': typeof testTestRoute
  '/chats/$sessionId': typeof AuthenticatedChatsSessionIdRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/payment/result': typeof AuthenticatedPaymentResultLazyRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceLazyRoute
  '/settings/earnings': typeof AuthenticatedSettingsEarningsLazyRoute
  '/settings/invite': typeof AuthenticatedSettingsInviteLazyRoute
  '/settings/user-card': typeof AuthenticatedSettingsUserCardLazyRoute
  '/admin-announcement': typeof AuthenticatedAdminAnnouncementIndexRoute
  '/analytics': typeof AuthenticatedAnalyticsIndexRoute
  '/editor': typeof AuthenticatedEditorIndexRoute
  '/prompts': typeof AuthenticatedPromptsIndexRoute
  '/recharge-orders': typeof AuthenticatedRechargeOrdersIndexRoute
  '/review': typeof AuthenticatedReviewIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/announcement': typeof AuthenticatedAnnouncementIndexLazyRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/messages': typeof AuthenticatedMessagesIndexLazyRoute
  '/payment': typeof AuthenticatedPaymentIndexLazyRoute
  '/settings/': typeof AuthenticatedSettingsIndexLazyRoute
  '/workshop': typeof AuthenticatedWorkshopIndexLazyRoute
  '/chats/new/$engineId': typeof AuthenticatedChatsNewEngineIdRoute
  '/admin/ai-providers': typeof AuthenticatedAdminAiProvidersIndexRoute
  '/admin/audit-logs': typeof AuthenticatedAdminAuditLogsIndexRoute
  '/admin/creator-earnings': typeof AuthenticatedAdminCreatorEarningsIndexRoute
  '/admin/guest-management': typeof AuthenticatedAdminGuestManagementIndexRoute
  '/admin/help-center': typeof AuthenticatedAdminHelpCenterIndexRoute
  '/admin/incentive': typeof AuthenticatedAdminIncentiveIndexRoute
  '/admin/system-configs': typeof AuthenticatedAdminSystemConfigsIndexRoute
  '/admin/system-engines': typeof AuthenticatedAdminSystemEnginesIndexRoute
  '/admin/templates': typeof AuthenticatedAdminTemplatesIndexRoute
  '/super-admin/admins': typeof AuthenticatedSuperAdminAdminsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/test': typeof testTestRoute
  '/chats/$sessionId': typeof AuthenticatedChatsSessionIdRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/payment/result': typeof AuthenticatedPaymentResultLazyRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceLazyRoute
  '/settings/earnings': typeof AuthenticatedSettingsEarningsLazyRoute
  '/settings/invite': typeof AuthenticatedSettingsInviteLazyRoute
  '/settings/user-card': typeof AuthenticatedSettingsUserCardLazyRoute
  '/admin-announcement': typeof AuthenticatedAdminAnnouncementIndexRoute
  '/analytics': typeof AuthenticatedAnalyticsIndexRoute
  '/editor': typeof AuthenticatedEditorIndexRoute
  '/prompts': typeof AuthenticatedPromptsIndexRoute
  '/recharge-orders': typeof AuthenticatedRechargeOrdersIndexRoute
  '/review': typeof AuthenticatedReviewIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/announcement': typeof AuthenticatedAnnouncementIndexLazyRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/messages': typeof AuthenticatedMessagesIndexLazyRoute
  '/payment': typeof AuthenticatedPaymentIndexLazyRoute
  '/settings': typeof AuthenticatedSettingsIndexLazyRoute
  '/workshop': typeof AuthenticatedWorkshopIndexLazyRoute
  '/chats/new/$engineId': typeof AuthenticatedChatsNewEngineIdRoute
  '/admin/ai-providers': typeof AuthenticatedAdminAiProvidersIndexRoute
  '/admin/audit-logs': typeof AuthenticatedAdminAuditLogsIndexRoute
  '/admin/creator-earnings': typeof AuthenticatedAdminCreatorEarningsIndexRoute
  '/admin/guest-management': typeof AuthenticatedAdminGuestManagementIndexRoute
  '/admin/help-center': typeof AuthenticatedAdminHelpCenterIndexRoute
  '/admin/incentive': typeof AuthenticatedAdminIncentiveIndexRoute
  '/admin/system-configs': typeof AuthenticatedAdminSystemConfigsIndexRoute
  '/admin/system-engines': typeof AuthenticatedAdminSystemEnginesIndexRoute
  '/admin/templates': typeof AuthenticatedAdminTemplatesIndexRoute
  '/super-admin/admins': typeof AuthenticatedSuperAdminAdminsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/(test)/test': typeof testTestRoute
  '/_authenticated/chats/$sessionId': typeof AuthenticatedChatsSessionIdRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/payment/result': typeof AuthenticatedPaymentResultLazyRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceLazyRoute
  '/_authenticated/settings/earnings': typeof AuthenticatedSettingsEarningsLazyRoute
  '/_authenticated/settings/invite': typeof AuthenticatedSettingsInviteLazyRoute
  '/_authenticated/settings/user-card': typeof AuthenticatedSettingsUserCardLazyRoute
  '/_authenticated/admin-announcement/': typeof AuthenticatedAdminAnnouncementIndexRoute
  '/_authenticated/analytics/': typeof AuthenticatedAnalyticsIndexRoute
  '/_authenticated/editor/': typeof AuthenticatedEditorIndexRoute
  '/_authenticated/prompts/': typeof AuthenticatedPromptsIndexRoute
  '/_authenticated/recharge-orders/': typeof AuthenticatedRechargeOrdersIndexRoute
  '/_authenticated/review/': typeof AuthenticatedReviewIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/announcement/': typeof AuthenticatedAnnouncementIndexLazyRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/_authenticated/messages/': typeof AuthenticatedMessagesIndexLazyRoute
  '/_authenticated/payment/': typeof AuthenticatedPaymentIndexLazyRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexLazyRoute
  '/_authenticated/workshop/': typeof AuthenticatedWorkshopIndexLazyRoute
  '/_authenticated/chats/new/$engineId': typeof AuthenticatedChatsNewEngineIdRoute
  '/_authenticated/admin/ai-providers/': typeof AuthenticatedAdminAiProvidersIndexRoute
  '/_authenticated/admin/audit-logs/': typeof AuthenticatedAdminAuditLogsIndexRoute
  '/_authenticated/admin/creator-earnings/': typeof AuthenticatedAdminCreatorEarningsIndexRoute
  '/_authenticated/admin/guest-management/': typeof AuthenticatedAdminGuestManagementIndexRoute
  '/_authenticated/admin/help-center/': typeof AuthenticatedAdminHelpCenterIndexRoute
  '/_authenticated/admin/incentive/': typeof AuthenticatedAdminIncentiveIndexRoute
  '/_authenticated/admin/system-configs/': typeof AuthenticatedAdminSystemConfigsIndexRoute
  '/_authenticated/admin/system-engines/': typeof AuthenticatedAdminSystemEnginesIndexRoute
  '/_authenticated/admin/templates/': typeof AuthenticatedAdminTemplatesIndexRoute
  '/_authenticated/super-admin/admins/': typeof AuthenticatedSuperAdminAdminsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/test'
    | '/chats/$sessionId'
    | '/errors/$error'
    | '/payment/result'
    | '/settings/appearance'
    | '/settings/earnings'
    | '/settings/invite'
    | '/settings/user-card'
    | '/admin-announcement'
    | '/analytics'
    | '/editor'
    | '/prompts'
    | '/recharge-orders'
    | '/review'
    | '/tasks'
    | '/users'
    | '/announcement'
    | '/help-center'
    | '/messages'
    | '/payment'
    | '/settings/'
    | '/workshop'
    | '/chats/new/$engineId'
    | '/admin/ai-providers'
    | '/admin/audit-logs'
    | '/admin/creator-earnings'
    | '/admin/guest-management'
    | '/admin/help-center'
    | '/admin/incentive'
    | '/admin/system-configs'
    | '/admin/system-engines'
    | '/admin/templates'
    | '/super-admin/admins'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/test'
    | '/chats/$sessionId'
    | '/errors/$error'
    | '/payment/result'
    | '/settings/appearance'
    | '/settings/earnings'
    | '/settings/invite'
    | '/settings/user-card'
    | '/admin-announcement'
    | '/analytics'
    | '/editor'
    | '/prompts'
    | '/recharge-orders'
    | '/review'
    | '/tasks'
    | '/users'
    | '/announcement'
    | '/help-center'
    | '/messages'
    | '/payment'
    | '/settings'
    | '/workshop'
    | '/chats/new/$engineId'
    | '/admin/ai-providers'
    | '/admin/audit-logs'
    | '/admin/creator-earnings'
    | '/admin/guest-management'
    | '/admin/help-center'
    | '/admin/incentive'
    | '/admin/system-configs'
    | '/admin/system-engines'
    | '/admin/templates'
    | '/super-admin/admins'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/settings'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/(test)/test'
    | '/_authenticated/chats/$sessionId'
    | '/_authenticated/errors/$error'
    | '/_authenticated/payment/result'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/earnings'
    | '/_authenticated/settings/invite'
    | '/_authenticated/settings/user-card'
    | '/_authenticated/admin-announcement/'
    | '/_authenticated/analytics/'
    | '/_authenticated/editor/'
    | '/_authenticated/prompts/'
    | '/_authenticated/recharge-orders/'
    | '/_authenticated/review/'
    | '/_authenticated/tasks/'
    | '/_authenticated/users/'
    | '/_authenticated/announcement/'
    | '/_authenticated/help-center/'
    | '/_authenticated/messages/'
    | '/_authenticated/payment/'
    | '/_authenticated/settings/'
    | '/_authenticated/workshop/'
    | '/_authenticated/chats/new/$engineId'
    | '/_authenticated/admin/ai-providers/'
    | '/_authenticated/admin/audit-logs/'
    | '/_authenticated/admin/creator-earnings/'
    | '/_authenticated/admin/guest-management/'
    | '/_authenticated/admin/help-center/'
    | '/_authenticated/admin/incentive/'
    | '/_authenticated/admin/system-configs/'
    | '/_authenticated/admin/system-engines/'
    | '/_authenticated/admin/templates/'
    | '/_authenticated/super-admin/admins/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
  testTestRoute: typeof testTestRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(test)/test': {
      id: '/(test)/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof testTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/workshop/': {
      id: '/_authenticated/workshop/'
      path: '/workshop'
      fullPath: '/workshop'
      preLoaderRoute: typeof AuthenticatedWorkshopIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/payment/': {
      id: '/_authenticated/payment/'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof AuthenticatedPaymentIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/messages/': {
      id: '/_authenticated/messages/'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AuthenticatedMessagesIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/announcement/': {
      id: '/_authenticated/announcement/'
      path: '/announcement'
      fullPath: '/announcement'
      preLoaderRoute: typeof AuthenticatedAnnouncementIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/review/': {
      id: '/_authenticated/review/'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof AuthenticatedReviewIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/recharge-orders/': {
      id: '/_authenticated/recharge-orders/'
      path: '/recharge-orders'
      fullPath: '/recharge-orders'
      preLoaderRoute: typeof AuthenticatedRechargeOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/prompts/': {
      id: '/_authenticated/prompts/'
      path: '/prompts'
      fullPath: '/prompts'
      preLoaderRoute: typeof AuthenticatedPromptsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/editor/': {
      id: '/_authenticated/editor/'
      path: '/editor'
      fullPath: '/editor'
      preLoaderRoute: typeof AuthenticatedEditorIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/analytics/': {
      id: '/_authenticated/analytics/'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthenticatedAnalyticsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin-announcement/': {
      id: '/_authenticated/admin-announcement/'
      path: '/admin-announcement'
      fullPath: '/admin-announcement'
      preLoaderRoute: typeof AuthenticatedAdminAnnouncementIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/user-card': {
      id: '/_authenticated/settings/user-card'
      path: '/user-card'
      fullPath: '/settings/user-card'
      preLoaderRoute: typeof AuthenticatedSettingsUserCardLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/invite': {
      id: '/_authenticated/settings/invite'
      path: '/invite'
      fullPath: '/settings/invite'
      preLoaderRoute: typeof AuthenticatedSettingsInviteLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/earnings': {
      id: '/_authenticated/settings/earnings'
      path: '/earnings'
      fullPath: '/settings/earnings'
      preLoaderRoute: typeof AuthenticatedSettingsEarningsLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/payment/result': {
      id: '/_authenticated/payment/result'
      path: '/payment/result'
      fullPath: '/payment/result'
      preLoaderRoute: typeof AuthenticatedPaymentResultLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chats/$sessionId': {
      id: '/_authenticated/chats/$sessionId'
      path: '/chats/$sessionId'
      fullPath: '/chats/$sessionId'
      preLoaderRoute: typeof AuthenticatedChatsSessionIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/super-admin/admins/': {
      id: '/_authenticated/super-admin/admins/'
      path: '/super-admin/admins'
      fullPath: '/super-admin/admins'
      preLoaderRoute: typeof AuthenticatedSuperAdminAdminsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/templates/': {
      id: '/_authenticated/admin/templates/'
      path: '/admin/templates'
      fullPath: '/admin/templates'
      preLoaderRoute: typeof AuthenticatedAdminTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/system-engines/': {
      id: '/_authenticated/admin/system-engines/'
      path: '/admin/system-engines'
      fullPath: '/admin/system-engines'
      preLoaderRoute: typeof AuthenticatedAdminSystemEnginesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/system-configs/': {
      id: '/_authenticated/admin/system-configs/'
      path: '/admin/system-configs'
      fullPath: '/admin/system-configs'
      preLoaderRoute: typeof AuthenticatedAdminSystemConfigsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/incentive/': {
      id: '/_authenticated/admin/incentive/'
      path: '/admin/incentive'
      fullPath: '/admin/incentive'
      preLoaderRoute: typeof AuthenticatedAdminIncentiveIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/help-center/': {
      id: '/_authenticated/admin/help-center/'
      path: '/admin/help-center'
      fullPath: '/admin/help-center'
      preLoaderRoute: typeof AuthenticatedAdminHelpCenterIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/guest-management/': {
      id: '/_authenticated/admin/guest-management/'
      path: '/admin/guest-management'
      fullPath: '/admin/guest-management'
      preLoaderRoute: typeof AuthenticatedAdminGuestManagementIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/creator-earnings/': {
      id: '/_authenticated/admin/creator-earnings/'
      path: '/admin/creator-earnings'
      fullPath: '/admin/creator-earnings'
      preLoaderRoute: typeof AuthenticatedAdminCreatorEarningsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/audit-logs/': {
      id: '/_authenticated/admin/audit-logs/'
      path: '/admin/audit-logs'
      fullPath: '/admin/audit-logs'
      preLoaderRoute: typeof AuthenticatedAdminAuditLogsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/ai-providers/': {
      id: '/_authenticated/admin/ai-providers/'
      path: '/admin/ai-providers'
      fullPath: '/admin/ai-providers'
      preLoaderRoute: typeof AuthenticatedAdminAiProvidersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chats/new/$engineId': {
      id: '/_authenticated/chats/new/$engineId'
      path: '/chats/new/$engineId'
      fullPath: '/chats/new/$engineId'
      preLoaderRoute: typeof AuthenticatedChatsNewEngineIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAppearanceLazyRoute: typeof AuthenticatedSettingsAppearanceLazyRoute
  AuthenticatedSettingsEarningsLazyRoute: typeof AuthenticatedSettingsEarningsLazyRoute
  AuthenticatedSettingsInviteLazyRoute: typeof AuthenticatedSettingsInviteLazyRoute
  AuthenticatedSettingsUserCardLazyRoute: typeof AuthenticatedSettingsUserCardLazyRoute
  AuthenticatedSettingsIndexLazyRoute: typeof AuthenticatedSettingsIndexLazyRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAppearanceLazyRoute:
      AuthenticatedSettingsAppearanceLazyRoute,
    AuthenticatedSettingsEarningsLazyRoute:
      AuthenticatedSettingsEarningsLazyRoute,
    AuthenticatedSettingsInviteLazyRoute: AuthenticatedSettingsInviteLazyRoute,
    AuthenticatedSettingsUserCardLazyRoute:
      AuthenticatedSettingsUserCardLazyRoute,
    AuthenticatedSettingsIndexLazyRoute: AuthenticatedSettingsIndexLazyRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedChatsSessionIdRoute: typeof AuthenticatedChatsSessionIdRoute
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
  AuthenticatedPaymentResultLazyRoute: typeof AuthenticatedPaymentResultLazyRoute
  AuthenticatedAdminAnnouncementIndexRoute: typeof AuthenticatedAdminAnnouncementIndexRoute
  AuthenticatedAnalyticsIndexRoute: typeof AuthenticatedAnalyticsIndexRoute
  AuthenticatedEditorIndexRoute: typeof AuthenticatedEditorIndexRoute
  AuthenticatedPromptsIndexRoute: typeof AuthenticatedPromptsIndexRoute
  AuthenticatedRechargeOrdersIndexRoute: typeof AuthenticatedRechargeOrdersIndexRoute
  AuthenticatedReviewIndexRoute: typeof AuthenticatedReviewIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedAnnouncementIndexLazyRoute: typeof AuthenticatedAnnouncementIndexLazyRoute
  AuthenticatedHelpCenterIndexLazyRoute: typeof AuthenticatedHelpCenterIndexLazyRoute
  AuthenticatedMessagesIndexLazyRoute: typeof AuthenticatedMessagesIndexLazyRoute
  AuthenticatedPaymentIndexLazyRoute: typeof AuthenticatedPaymentIndexLazyRoute
  AuthenticatedWorkshopIndexLazyRoute: typeof AuthenticatedWorkshopIndexLazyRoute
  AuthenticatedChatsNewEngineIdRoute: typeof AuthenticatedChatsNewEngineIdRoute
  AuthenticatedAdminAiProvidersIndexRoute: typeof AuthenticatedAdminAiProvidersIndexRoute
  AuthenticatedAdminAuditLogsIndexRoute: typeof AuthenticatedAdminAuditLogsIndexRoute
  AuthenticatedAdminCreatorEarningsIndexRoute: typeof AuthenticatedAdminCreatorEarningsIndexRoute
  AuthenticatedAdminGuestManagementIndexRoute: typeof AuthenticatedAdminGuestManagementIndexRoute
  AuthenticatedAdminHelpCenterIndexRoute: typeof AuthenticatedAdminHelpCenterIndexRoute
  AuthenticatedAdminIncentiveIndexRoute: typeof AuthenticatedAdminIncentiveIndexRoute
  AuthenticatedAdminSystemConfigsIndexRoute: typeof AuthenticatedAdminSystemConfigsIndexRoute
  AuthenticatedAdminSystemEnginesIndexRoute: typeof AuthenticatedAdminSystemEnginesIndexRoute
  AuthenticatedAdminTemplatesIndexRoute: typeof AuthenticatedAdminTemplatesIndexRoute
  AuthenticatedSuperAdminAdminsIndexRoute: typeof AuthenticatedSuperAdminAdminsIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedChatsSessionIdRoute: AuthenticatedChatsSessionIdRoute,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
  AuthenticatedPaymentResultLazyRoute: AuthenticatedPaymentResultLazyRoute,
  AuthenticatedAdminAnnouncementIndexRoute:
    AuthenticatedAdminAnnouncementIndexRoute,
  AuthenticatedAnalyticsIndexRoute: AuthenticatedAnalyticsIndexRoute,
  AuthenticatedEditorIndexRoute: AuthenticatedEditorIndexRoute,
  AuthenticatedPromptsIndexRoute: AuthenticatedPromptsIndexRoute,
  AuthenticatedRechargeOrdersIndexRoute: AuthenticatedRechargeOrdersIndexRoute,
  AuthenticatedReviewIndexRoute: AuthenticatedReviewIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedAnnouncementIndexLazyRoute:
    AuthenticatedAnnouncementIndexLazyRoute,
  AuthenticatedHelpCenterIndexLazyRoute: AuthenticatedHelpCenterIndexLazyRoute,
  AuthenticatedMessagesIndexLazyRoute: AuthenticatedMessagesIndexLazyRoute,
  AuthenticatedPaymentIndexLazyRoute: AuthenticatedPaymentIndexLazyRoute,
  AuthenticatedWorkshopIndexLazyRoute: AuthenticatedWorkshopIndexLazyRoute,
  AuthenticatedChatsNewEngineIdRoute: AuthenticatedChatsNewEngineIdRoute,
  AuthenticatedAdminAiProvidersIndexRoute:
    AuthenticatedAdminAiProvidersIndexRoute,
  AuthenticatedAdminAuditLogsIndexRoute: AuthenticatedAdminAuditLogsIndexRoute,
  AuthenticatedAdminCreatorEarningsIndexRoute:
    AuthenticatedAdminCreatorEarningsIndexRoute,
  AuthenticatedAdminGuestManagementIndexRoute:
    AuthenticatedAdminGuestManagementIndexRoute,
  AuthenticatedAdminHelpCenterIndexRoute:
    AuthenticatedAdminHelpCenterIndexRoute,
  AuthenticatedAdminIncentiveIndexRoute: AuthenticatedAdminIncentiveIndexRoute,
  AuthenticatedAdminSystemConfigsIndexRoute:
    AuthenticatedAdminSystemConfigsIndexRoute,
  AuthenticatedAdminSystemEnginesIndexRoute:
    AuthenticatedAdminSystemEnginesIndexRoute,
  AuthenticatedAdminTemplatesIndexRoute: AuthenticatedAdminTemplatesIndexRoute,
  AuthenticatedSuperAdminAdminsIndexRoute:
    AuthenticatedSuperAdminAdminsIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
  testTestRoute: testTestRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
